import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import './infobox.scss';
export default function InfoBox({ feedback, firstInfoBoxLine, background, link }) {
    const className = background ? 'info-box-error-background' : 'info-box-error';
    return (_jsxs("div", { className: className, children: [feedback, _jsx("h3", { children: firstInfoBoxLine })] }));
}
InfoBox.defaultProps = {
    background: true,
    feedback: null,
    firstInfoBoxLine: '',
    link: false,
};
InfoBox.propTypes = {
    background: PropTypes.bool,
    feedback: PropTypes.element,
    firstInfoBoxLine: PropTypes.string,
    link: PropTypes.bool,
};
